import { Object, Optional, Static, String, Array, Boolean } from '@sinclair/typebox';

import { DapiError, DapiWarning, NonEligibilityReasons } from '../../../..';

export enum BoundStatus {
  DISRUPTED = 'disrupted',
  ACKNOWLEDGED = 'acknowledged',
  SELF_REACCOMMODATED = 'selfReaccommodated',
}

const Location = Object({
  location: String(),
  airportCode: String(),
  dateTime: String(),
});
type Location = Static<typeof Location>;

const SegmentAirlineInfo = Object({
  marketingAirlineCode: String(),
  operatingAirlineCode: Optional(String()),
  marketingFlightNumber: String(),
  operatingAirlineFlightNumber: Optional(String()),
  departure: Location,
  arrival: Location,
});
type SegmentAirlineInfo = Static<typeof SegmentAirlineInfo>;

const DisruptedSegmentInfo = Object({
  marketingAirlineCode: String(),
  operatingAirlineCode: Optional(String()),
  marketingFlightNumber: String(),
  operatingAirlineFlightNumber: Optional(String()),
  departure: Location,
  arrival: Location,
});
type DisruptedSegmentInfo = Static<typeof DisruptedSegmentInfo>;

export const SelfReaccommodationEligibilityBound = Object({
  alternativeOfferBoundId: String(),
  segments: Array(SegmentAirlineInfo),
  boundStatus: Optional(String()),
  disruptedSegments: Optional(Array(DisruptedSegmentInfo)),
  isAcknowledgeable: Optional(Boolean()),
  nonAcknowledgeableReasons: Optional(Array(NonEligibilityReasons)),
  isRebookable: Optional(Boolean()),
  nonRebookableReasons: Optional(Array(NonEligibilityReasons)),
});
export type SelfReaccommodationEligibilityBound = Static<typeof SelfReaccommodationEligibilityBound>;

export const SelfReaccommodationEligibilityResponse = Object({
  bounds: Array(SelfReaccommodationEligibilityBound),
  warnings: Optional(Array(DapiWarning)),
  errors: Optional(Array(DapiError)),
});
export type SelfReaccommodationEligibilityResponse = Static<typeof SelfReaccommodationEligibilityResponse>;
